<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Elem Group</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">DosisNombre</th>
          <th scope="col">GrupoEtareoNombre</th>
          <th scope="col">FrecuenciaNombre</th>
          <th scope="col">ElementoNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="elemgrup in datosPaginados" :key="elemgrup.idElemGrup">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(elemgrup.idElemGrup)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(elemgrup.idElemGrup)" title="Editar">edit_square</i></td>
          <td>{{elemgrup.dosisNombre}}</td>
          <td>{{elemgrup.grupoEtareoNombre}}</td>
          <td>{{elemgrup.frecuenciaNombre}}</td>
          <td>{{elemgrup.elementoNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteElemGrup(elemgrup.idElemGrup)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idElemGrup" class="form-label">IdElemGrup</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idElemGrup" name="idElemGrup" v-model="datoElemGrup.idElemGrup" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Elemento -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idElemento" class="form-label"> Elemento</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idElemento" name="idElemento" v-model="datoElemGrup.idElemento">
                      <option v-for="elemento in elementos" :value="elemento.idElemento" :key="elemento.idElemento">
                        {{ elemento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Elemento -->
<!-- Botón Lista de Valores  Grupo Etareo -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idGrupoEtareo" class="form-label"> Grupo Etareo</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idGrupoEtareo" name="idGrupoEtareo" v-model="datoElemGrup.idGrupoEtareo">
                      <option v-for="grupoEtareo in grupoEtareos" :value="grupoEtareo.idGrupoEtareo" :key="grupoEtareo.idGrupoEtareo">
                        {{ grupoEtareo.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Grupo Etareo -->
<!-- Botón Lista de Valores  Frecuencia -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idFrecuencia" class="form-label"> Frecuencia</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idFrecuencia" name="idFrecuencia" v-model="datoElemGrup.idFrecuencia">
                      <option v-for="frecuencia in frecuencias" :value="frecuencia.idFrecuencia" :key="frecuencia.idFrecuencia">
                        {{ frecuencia.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Frecuencia -->
<!-- Botón Lista de Valores  Dosis -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idDosis" class="form-label"> Dosis</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idDosis" name="idDosis" v-model="datoElemGrup.idDosis">
                      <option v-for="dosis in dosiss" :value="dosis.idDosis" :key="dosis.idDosis">
                        {{ dosis.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Dosis -->
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarElemGrup" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditElemGrup" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      elemgrups : [],
      datoElemGrup : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      elementos: [],
      grupoEtareos: [],
      frecuencias: [],
      dosiss: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchElementos()
    this.fetchGrupoEtareos()
    this.fetchFrecuencias()
    this.fetchDosiss()
  },
  methods : {
    totalPaginas(){
      return Math.ceil(this.elemgrups.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwelemgrups/nombre/'+this.nombreBusqueda).then(response=>{
          this.elemgrups=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.elemgrups.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwelemgrups').then(response=>{
      this.elemgrups=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.elemgrups.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idElemento'
        ,'idGrupoEtareo'
        ,'idFrecuencia'
        ,'idDosis'
      ];
      const requiredFieldsText = [
        'idElemento'
        ,'idGrupoEtareo'
        ,'idFrecuencia'
        ,'idDosis'
      ];
      return validarForm(this.datoElemGrup, requiredFields, requiredFieldsText);
    },
    async guardarElemGrup(){
      if(this.validarForm() === 1){
        try {
          await api.post('/elemgrups', this.datoElemGrup)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "ElemGrup creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditElemGrup(){
      if(this.validarForm() === 1){
        try {
          await api.post('/elemgrups', this.datoElemGrup)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ElemGrup creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoElemGrup={}
      this.titulo   = 'Crear Elem Group'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idElemGrup){
      this.modalWindow = true
      if(idElemGrup != null){    
           api.get('/vwelemgrups/'+idElemGrup).then(resp=>{
          this.datoElemGrup = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Elem Group'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idElemGrup){
      if(idElemGrup != null){
        this.$router.push('/elemgrupmd/'+idElemGrup)
      }
    },
    async deleteElemGrup (idElemGrup) {
      try{
        await api.delete('/elemgrups/'+idElemGrup)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchElementos() {
      fetch('http://localhost:8080/api/v1/elementos')
        .then(response => response.json())
        .then(data => {
          this.elementos = data;
        })
        .catch(error => {
          console.error('Error fetching elementos:', error);
        });
    },
    fetchGrupoEtareos() {
      fetch('http://localhost:8080/api/v1/grupoetareos')
        .then(response => response.json())
        .then(data => {
          this.grupoEtareos = data;
        })
        .catch(error => {
          console.error('Error fetching grupoEtareos:', error);
        });
    },
    fetchFrecuencias() {
      fetch('http://localhost:8080/api/v1/frecuencias')
        .then(response => response.json())
        .then(data => {
          this.frecuencias = data;
        })
        .catch(error => {
          console.error('Error fetching frecuencias:', error);
        });
    },
    fetchDosiss() {
      fetch('http://localhost:8080/api/v1/dosiss')
        .then(response => response.json())
        .then(data => {
          this.dosiss = data;
        })
        .catch(error => {
          console.error('Error fetching dosiss:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
